export default __webpack_public_path__ + "static/media/character9.dcd0dbe7.png";